import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageNode } from 'src/app/dto';

@Component({
    selector: 'app-image-node',
    templateUrl: './image-node.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageNodeComponent {
    @Input() node: ImageNode;
}
